import styled from "styled-components";

export const Container = styled.ul``;

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  margin: .5rem 0;
`;
